// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__39JFO","footer":"ModalInfo_footer__weZCr"};